import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import NavBar from "../components/navBar/NavBar";
import FooterComponent from "../components/footer/FooterComponent";
import { phases } from "../data/data";
import "../styles/courseDetails.css";

const CourseDetails = () => {
  const { id } = useParams(); // react-router-dom param
  const navigate = useNavigate();
  const [fadeIn, setFadeIn] = useState(false);

  const phase = phases.find((p) => String(p.id) === id);

  useEffect(() => {
    const timer = setTimeout(() => setFadeIn(true), 100);
    return () => clearTimeout(timer);
  }, []);

  if (!phase) return <div style={{ padding: 20 }}>Course not found</div>;

  const isMobile = window.innerWidth < 768;

  return (
    <div className="course-details-page">
      <NavBar />

      <div className={`course-details-wrapper ${fadeIn ? "fade-in" : ""}`} style={{padding:"0px 16px", marginBottom:isMobile ? 100:150}}>
        <h1
          className="course-title"
          style={{ fontSize: isMobile ? 20 : 30 }}
        >
          {phase.title}
        </h1>

        <p
          className="course-content"
          style={{ fontSize: isMobile ? 14 : 16 }}
        >
          {phase.content || "Details about this course will appear here soon."}
        </p>

        {phase.image && (
          <img
            src={phase.image}
            alt="Course"
            className="course-image"
            style={{ width: isMobile ? 300 : 500, height: isMobile ? 200 : 500 }}
          />
        )}

        {phase.description?.map((desc, index) => (
          <div key={index} className="course-desc-block">
            <p
              className="course-desc-subtitle"
              style={{ fontSize: isMobile ? 16 : 18 }}
            >
              {desc.subtitle}
            </p>
            {Object.keys(desc).map((key) =>
              key.startsWith("points") ? (
                <p
                  key={key}
                  className="course-desc-points"
                  style={{ fontSize: isMobile ? 14 : 16 }}
                >
                  {desc[key]}
                </p>
              ) : null
            )}
          </div>
        ))}

        <div
          className="register-button"
          onClick={() => navigate(`/register/${phase.id}`)}
        >
          Register Now!
        </div>
      </div>

      <FooterComponent />
    </div>
  );
};

export default CourseDetails;
